import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const ServicesCard = ({ image, text, isLeft, navigateTo }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={isLeft ? { opacity: 0, x: -50 } : { opacity: 0, x: 50 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{
        duration: 1,
        delay: 0.5,
      }}
      className="flex justify-center items-center relative z-2 col-span-2 md:col-span-1 h-[250px] md:h-[350px] lg:h-[400px]"
      onClick={() => navigate(navigateTo)}
    >
      <div className="w-full h-full bg-black opacity-[0.5]">
        <img className="h-full w-full object-cover relative z-0" src={image} />
      </div>

      <div className="flex flex-col gap-[15px] items-center absolute ">
        <h2 className="text-yellow text-[20px] sm:text-[25px] md:text-[28px] lg:text-[35px] max-w-[450px] text-center font-extrabold uppercase">
          {text}
        </h2>
        <div
          className={`flex justify-center items-center uppercase w-fit mt-[10px] lg:mt-0 py-[8px] lg:py-[10px] px-[10px] lg:px-[20px] border-yellow border-[5px] text-white hover:bg-yellow transition-all duration-400 cursor-pointer ${
            isLeft ? "md:border-r-0" : "md:border-l-0"
          }`}
        >
          More details
        </div>
      </div>
    </motion.div>
  );
};

export default ServicesCard;
